export default __webpack_public_path__ + "static/Pattern3-8bbacefaae8221a2c294a623ed3ef626.png";